import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-artwork-found-solution',
  templateUrl: './artwork-found-solution.component.html',
  styleUrls: ['./artwork-found-solution.component.scss']
})
export class ArtworkFoundSolutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
